import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import { call, select } from 'redux-saga/effects';
import { AccountResource } from '../../core/resources/account.resource';
import { MembersResource } from '../../core/resources/members.resource';
import { compatibilityReportSerializer } from '../../models/compatibilityReport/compatibilityReport.serializer';
import { compatiblityReportSerializer } from '../../models/member/coreMember.serializer';
import {
  ECompatibilityReportType,
  EIncludedType,
  IApiMemberProfile,
} from '../../models/member/member.types';
import { memberProfileSerializer } from '../../models/member/memberProfile.serializer';
import { IMemberChoices } from '../../models/memberchoice/memberchoice.types';

export function* getMemberChoices(accountId: string) {
  return yield call(MembersResource.getMemberChoicesByAccountId, accountId);
}

export function* postMemberChoices(payload: IMemberChoices) {
  const accountId = yield select(selectAccountId);
  const response = yield call(
    MembersResource.postReflistChoices,
    accountId,
    payload
  );

  return response;
}

export function* patchMemberAnnounce(payload: string) {
  return yield call(MembersResource.updateAnnounce, payload);
}

export function* postHiddenProfile() {
  const accountId = yield select(selectAccountId);

  return yield call(MembersResource.postHiddenProfile, accountId);
}

export function* patchHasCompletedProfile() {
  return yield call(AccountResource.patchHasCompletedProfile);
}

export function* getCompatibilityReportLight(otherAccountId: string) {
  const myAccountId = yield select(selectAccountId);
  const response = yield call(
    MembersResource.getCompatibilityReportLight,
    myAccountId,
    otherAccountId
  );

  return compatiblityReportSerializer(response.data, otherAccountId);
}

export function* getCompatibilityReport(
  reportType: ECompatibilityReportType,
  otherAccountId: string
) {
  const myAccountId: string = yield select(selectAccountId);
  const compatibilityReport = yield call(
    MembersResource.getCompatibilityReport,
    myAccountId,
    reportType,
    otherAccountId
  );

  return compatibilityReportSerializer(compatibilityReport);
}

export function* getMemberProfile(
  accountId: string,
  includes?: EIncludedType[]
) {
  const response: IApiMemberProfile = yield call(
    MembersResource.getMemberByAccountId,
    accountId,
    includes
  );

  return {
    [response.data.id]: memberProfileSerializer(response.data, response),
  };
}
